import { AxiosClient } from "./AxiosClient";
import { BASE_URL } from "./config";

// ─────────────────────────────────────────────────────────────────────────────
// CRUD
// ─────────────────────────────────────────────────────────────────────────────

export const createReport = async () => {
  try {
    const res = await AxiosClient.post(
      "reports/create",
      {},
      { useTarget: true },
    );
    return res;
  } catch (e) {
    console.error("createReport error:", e);
    return null;
  }
};

export const listReports = async () => {
  try {
    const res = await AxiosClient.get("reports/list", { useTarget: true });
    return res;
  } catch (e) {
    console.error("listReports error:", e);
    return null;
  }
};

export const getReport = async (reportId) => {
  try {
    const res = await AxiosClient.get("reports/get/" + reportId);
    return res;
  } catch (e) {
    console.error("getReport error:", e);
    return null;
  }
};

export const deleteReport = async (reportId) => {
  try {
    const res = await AxiosClient.delete("reports/delete/" + reportId);
    return res;
  } catch (e) {
    console.error("deleteReport error:", e);
    return null;
  }
};

export const renameReport = async (reportId, title) => {
  try {
    const res = await AxiosClient.put("reports/rename/" + reportId, { title });
    return res;
  } catch (e) {
    console.error("renameReport error:", e);
    return null;
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// Undo / Redo
// ─────────────────────────────────────────────────────────────────────────────

export const undoReport = async (reportId) => {
  try {
    const res = await AxiosClient.post("reports/undo", { report_id: reportId });
    return res;
  } catch (e) {
    console.error("undoReport error:", e);
    return e?.response || null;
  }
};

export const redoReport = async (reportId) => {
  try {
    const res = await AxiosClient.post("reports/redo", { report_id: reportId });
    return res;
  } catch (e) {
    console.error("redoReport error:", e);
    return e?.response || null;
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// Highlighted edit suggestions
// ─────────────────────────────────────────────────────────────────────────────

export const previewReportEdit = async ({
  reportId,
  revision,
  selection,
  instruction,
  op = "replace_range",
  sourceMode = "",
  companyName,
}) => {
  try {
    const res = await AxiosClient.post("reports/edit/preview", {
      report_id: reportId,
      revision,
      op,
      selection,
      instruction,
      ...(sourceMode ? { source_mode: sourceMode } : {}),
      ...(companyName ? { target: companyName } : {}),
    });
    return res;
  } catch (e) {
    console.error("previewReportEdit error:", e);
    return e?.response || null;
  }
};

export const applyReportEdit = async ({ reportId, editId, baseRevision }) => {
  try {
    const res = await AxiosClient.post("reports/edit/apply", {
      report_id: reportId,
      edit_id: editId,
      base_revision: baseRevision,
    });
    return res;
  } catch (e) {
    console.error("applyReportEdit error:", e);
    return e?.response || null;
  }
};

export const rejectReportEdit = async ({ reportId, editId }) => {
  try {
    const res = await AxiosClient.post("reports/edit/reject", {
      report_id: reportId,
      edit_id: editId,
    });
    return res;
  } catch (e) {
    console.error("rejectReportEdit error:", e);
    return e?.response || null;
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// Streaming chat — uses raw fetch (axios doesn't support ReadableStream)
// ─────────────────────────────────────────────────────────────────────────────

export const streamReportChat = async ({
  reportId,
  message,
  userDatetime,
  signal,
  companyName,
}) => {
  try {
    const token = localStorage.getItem("user");
    const res = await fetch(BASE_URL + "reports/chat", {
      method: "POST",
      headers: {
        ...(token ? { "x-access-token": token } : {}),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        report_id: reportId,
        message,
        user_datetime: userDatetime,
        target: companyName,
      }),
      signal,
      useTarget: true,
    });
    return res;
  } catch (e) {
    if (e.name !== "AbortError") {
      console.error("streamReportChat error:", e);
    }
    return null;
  }
};
